/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Header_ActionInputs */

const en_header_action = /** @type {(inputs: Header_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Act`)
};

/**
* | output |
* | --- |
* | "Act" |
*
* @param {Header_ActionInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const header_action = /** @type {((inputs?: Header_ActionInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Header_ActionInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_header_action(inputs)
});